import { useState } from "react";
import { motion } from "framer-motion";
import { Sparkles, CheckCircle2 } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import TheoryBlock from "./TheoryBlock";
import CheckpointBlock from "./CheckpointBlock";
import MatchBlock from "./MatchBlock";
import OrderBlock from "./OrderBlock";
import ScenarioBlock from "./ScenarioBlock";
import VideoBlock from "./VideoBlock";
import SlideBlock from "./SlideBlock";

const RENDERERS = { slide: SlideBlock, theory: TheoryBlock, checkpoint: CheckpointBlock, match: MatchBlock, order: OrderBlock, scenario: ScenarioBlock, video: VideoBlock };

export const InteractiveSlides = ({ slides, onFinished }) => {
  const { t } = useLang();
  const [idx, setIdx] = useState(0);
  const [done, setDone] = useState(false);
  const [correct, setCorrect] = useState(0);
  const graded = slides.filter((b) => ["checkpoint", "match", "order"].includes(b.type)).length;

  const next = (value) => {
    const block = slides[idx];
    if (block.type === "checkpoint" && value === block.correct_index) setCorrect((c) => c + 1);
    if (block.type === "match" || block.type === "order") setCorrect((c) => c + (value ? 1 : 0));
    if (idx + 1 >= slides.length) { setDone(true); onFinished?.(); } else setIdx(idx + 1);
  };

  if (done) {
    return (
      <div className="card-dark p-8 text-center" data-testid="live-slides-done">
        <CheckCircle2 className="w-10 h-10 text-[#1D4ED8] mx-auto" />
        <h3 className="font-heading font-black text-2xl text-[#0B1B3A] mt-3">{t("live.slidesDone")}</h3>
        <p className="text-sm text-[#475569] mt-2">{t("live.slidesScore")}: {correct}/{graded}</p>

      </div>
    );
  }
  const block = slides[idx];
  const Renderer = RENDERERS[block.type] || TheoryBlock;
  return (
    <div data-testid="live-slides">
      <div className="flex items-center justify-between text-xs font-bold uppercase tracking-[0.18em] text-[#64748B] mb-3">
        <span className="inline-flex items-center gap-1.5"><Sparkles className="w-4 h-4 text-[#1D4ED8]" /> {t("live.interactive")}</span>
        <span data-testid="live-slides-progress">{idx + 1}/{slides.length}</span>
      </div>
      <div className="h-1.5 bg-[#E2E8F0] rounded-full overflow-hidden mb-6"><motion.div className="h-full bg-[#1D4ED8]" animate={{ width: `${((idx + 1) / slides.length) * 100}%` }} /></div>
      <div className="slide-stack" data-testid="slide-stack">
        <Renderer key={idx} block={block} onDone={next} />
      </div>
    </div>
  );
};

export default InteractiveSlides;
